import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(requestMojoComponents),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchWFCmsRequestMojoComponents);

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { put, call, takeEvery } from 'redux-saga/effects';
import { workingStart, workingEnd } from '../../working/actions';
import logger from '../../../logger/logger';
import extractJson from '../../../../lib/extract-json/extract-json';
import get from '../../../network/get';
import post from '../../../network/post';
import * as actions from '../actions';
export var getData = function getData(url) {
  return get({
    url: url
  });
};
export var postData = function postData(url) {
  return post({
    url: url
  });
};
export var extractData = function extractData(data) {
  return extractJson(data);
};
export function requestMojoComponents(_ref) {
  var navigationUrl, mojoComponentsRaw, mojoData, mojoComponents, validMojoResponse, mojoError;
  return regeneratorRuntime.wrap(function requestMojoComponents$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          navigationUrl = _ref.navigationUrl;
          _context.next = 3;
          return put(workingStart());

        case 3:
          _context.prev = 3;

          if (!navigationUrl) {
            _context.next = 22;
            break;
          }

          _context.next = 7;
          return call(getData, navigationUrl);

        case 7:
          mojoComponentsRaw = _context.sent;
          mojoData = mojoComponentsRaw;

          if (_typeof(mojoComponentsRaw) === 'object' && mojoComponentsRaw !== null && !Array.isArray(mojoComponentsRaw)) {
            if (mojoComponentsRaw && mojoComponentsRaw.data) {
              mojoData = mojoComponentsRaw.data;
            }
          }

          _context.next = 12;
          return call(extractData, mojoData);

        case 12:
          mojoComponents = _context.sent;
          validMojoResponse = mojoComponents && _typeof(mojoComponents) === 'object' && !Array.isArray(mojoComponents) && Object.keys(mojoComponents).length;

          if (!validMojoResponse) {
            _context.next = 19;
            break;
          }

          _context.next = 17;
          return put(actions.wfCmsSetMojoComponents({
            mojoComponents: mojoComponents
          }));

        case 17:
          _context.next = 20;
          break;

        case 19:
          throw new Error('invalid response');

        case 20:
          _context.next = 23;
          break;

        case 22:
          throw new Error('navigationUrl is not defined');

        case 23:
          _context.next = 31;
          break;

        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](3);
          mojoError = {
            'status': {
              'status': false
            }
          };
          _context.next = 30;
          return put(actions.wfCmsSetMojoComponents({
            mojoComponents: mojoError
          }));

        case 30:
          logger.error('MOJODATA: (ERROR) exception in network call', _context.t0);

        case 31:
          _context.prev = 31;
          _context.next = 34;
          return put(workingEnd());

        case 34:
          return _context.finish(31);

        case 35:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 25, 31, 35]]);
}
export function watchWFCmsRequestMojoComponents() {
  return regeneratorRuntime.wrap(function watchWFCmsRequestMojoComponents$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(actions.WF_CMS_REQUEST_MOJO_COMPONENTS, requestMojoComponents);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}